










import {Component, Prop} from 'vue-property-decorator';
import Form from '@/layouts/Form';

import InputDefault from '@/components/input/Input.vue';

import DifficultiesModule from '@/store/difficulties/entity';

@Component({
    components: {
        InputDefault,
    },
})
export default class DifficultiesModuleForm extends Form {
    @Prop({}) formValues?: any;
    @Prop({ type: Object, default: () => ({}) }) errors!: Record<string, string>;

    values: any = {
        title: '',
        type: 9999
    }

    get model() {
        return DifficultiesModule.model;
    }

    returnBefore() {
        this.$router.push({name: 'difficulties'});
    }

    initFormValues() {
        if (!this.formValues) {
            return;
        }

        const {
            title = '',
            sort = 9999,
        } = this.formValues;

        this.values = {
            title,
            sort
        }
    }

    async createNew() {
        return this.update();
    }

    async update() {
        const data = this.prepareData();

        this.$emit('submit', data);
    }

    prepareData() {
        const {
            title,
            sort
        } = this.values;

        const request: any =  {
            title,
            sort,
        };

        return request;
    }

    async mounted() {
        this.initFormValues();
    }
}
